<ui-page-container>
  <mat-card class="media-page-content">
    <mat-card-title>{{ 'Operazioni' | translate }}</mat-card-title>
    <div class="alert-warning">
      <p>{{ 'La visualizzazione di alcune risorse collegate all\'operazione potrebbero non essere disponibili qualora il dato sia stato rimosso dal sistema in qualunque momento.' | translate }}</p>
    </div>
    <mat-card-content>
      <ui-table
        [filters]="filters$ | async"
        [rowSelection]="'checkbox'"
        [fields]="fields"
        [pager]="pager$"
        [reload]="reload$"
        [itemsPage]="(page$ | async)?.current"
        [itemsPerPage]="(page$ | async)?.limit"
        [contextMenuActions]="contextMenus"
        (itemsPageChange)="applyChangePageHandler($event)">
        <div tableFilters>
          <ui-filters
            [dialogFilters]="MobileFiltersComponent"
            (action)="applyFilterWithDelayHandler($event)">
            <app-audits-filters
              [filters]="filtersObj$ | async"
              #desktopFilter>
            </app-audits-filters>
          </ui-filters>
        </div>
      </ui-table>
    </mat-card-content>
  </mat-card>
</ui-page-container>
